// sticky scroll
window.onscroll = function() {myFunction()};

var header = document.getElementById("shopify-section-header");
var preheader = document.getElementById("announce");
var main = document.getElementById("PageContainer");
var bod = document.getElementsByTagName("BODY")[0]; 
var sticky = header.offsetTop + 0.2;
var container= header.offsetWidth;
var bodwidth= bod.offsetWidth;


function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
    if (bodwidth >= 1900) {
    	header.style.maxWidth=container + "px";
    }
    main.style.marginTop = preheader.offsetHeight + "px";
  } else {
    header.classList.remove("sticky");
    if (bodwidth >= 1900) {
    	header.style.maxWidth="auto";
    }
    main.style.marginTop = "0px";
  }
}

/*

////// BRUSHBOX

*/

// Brushbox - reset fields in brusbox


  function resetBrushbox(){
    //alert("test button");
    //original page
  	$('.toggle-opt-size input[opt="opt-inp-0"], .toggle-opt-style input[opt="opt-inp-0"]').prop("checked", true);
  	$('.toggle-opt-size input[opt="opt-inp-1"], .toggle-opt-style input[opt="opt-inp-1"]').prop("checked", false);
    
    
    
    $('.option-size .toggle, .option-style .toggle, .option-tabs .toggle, .option-billing .toggle ').removeClass("active-tog");
    $('.product-customizer-options input, #myInput ').val('');
    $('.popup-main').removeClass("show-popup-main");
    $('.popup-cover').removeClass("show-popup-cover");
    $('.owl-set-product').trigger('to.owl.carousel', '0');
    //$( ".option-brush input" ).prop( "checked", false )
    $('.pre-save-text').removeClass('d-none').addClass('d-inline');
    
    
    // Reset variant id's
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          var sizeval = $(".option-size").attr('value');
          var getNewId = options.annual.tabs.adult[thevar];
          $( this ).attr('set-id',getNewId);
        });
    
    
    
    var setbill = 'annual';
        $( ".owl-item .item" ).each(function() {
         var setSizeOpt = $(this).attr("size");
          var setcolOpt = $(this).attr("col");
         var lowersize = ""; 
          lowersize = "adult";
          
          var setNewId = options[setbill].tabs[lowersize][setcolOpt];
          $(this).attr("id",setNewId);
        });
    
    var chosenId;
    chosenId = $('.col-smooth .circ:nth-child(1)').attr('set-id');
    $('.option-colour').attr('value', chosenId);
    $('.option-colour .col-curvy').css('display', "none");
    $('.option-colour .col-smooth').css('display', "block");
    
    if(!$('.img-tabs').hasClass('tabs-show')){
       $('.img-tabs').addClass('tabs-show'); 
    };
    
    
    // resetting option values
    $('.option-tabs').attr('value', 'yes');
    $('.option-billing').attr('value', 'annual');
    $('.option-style').attr('value', 'smooth');
    $('.option-size').attr('value', 'adult');
    
    // resetting checkbox settings
    $('.option-size, .option-style,.option-colour').removeClass("disable-sect");
    $('.owl-set-product').removeClass("hide-brush");
    $('.option-brush .checkbox-label input[type=checkbox]').prop('checked', false); // Unchecks it
    
    //resetting colour chart
     $('.col-smooth .circ, .col-curvy .circ').removeClass('active');
    $('.col-smooth .circ:nth-child(1)').addClass('active');
    
    
    
    
    

    //additional text - resetting to preferred option
    var setText = "You will receive a fresh brush every other month, and be charged £78 annually on the anniversary of your first order. You can edit, pause or cancel your subscription at any time.";
    $('.prompt-deliver-plus').addClass('d-none');
    $('.ori-cost').text('6.50*');
    $('.pre-saving').removeClass('d-none');
    $('.pre-saving-before').text('108*');
    $('.save-cost').text('£30');
    $('.pre-saving-after').text('78');
    $('.set-text-add').text(setText);
    
    
  }



// POPUP - Alternative popup option

function secondPopup(){
  resetBrushbox();
  //alert('testing');
  
    setImg = "https://cdn.shopify.com/s/files/1/2172/8211/files/pop-case.jpg?v=1600853746";
    setTitle = "Don't miss out!";
    setText = '<p>Before you go, take a quick look at our most popular one-time purchases which complement your subscription</p>';
    setBut = '<a type="button" href="/pages/additional-products" class="btn btn-fill btn-org margin-b-xs but-another">Show me</a><a href="/cart" class="btn btn-outline btn-org">Go to checkout</a></div>';
 
  
    setTimeout(function () {

 
  $('.popup-main .pop-img').css("background-image", "url(" + setImg + ")"); 
  $('.popup-main .pop-title').html(setTitle); 
  $('.popup-main .pop-cont').html(setText); 
  $('.popup-main .pop-but').html(setBut); 
  
      $('.popup-main').addClass("show-popup-main");
    $('.popup-cover').addClass("show-popup-cover");  
  
      }, 500); 
  
}



function curvychoose(optchosensize){
  if(optchosensize == "kid"){
    $(".curv-adult").addClass('hide-curv-opt');
    $(".curv-kid").removeClass('hide-curv-opt');
  }else{
    $(".curv-kid").addClass('hide-curv-opt');
    $(".curv-adult").removeClass('hide-curv-opt');
  }
}




function goToCarousel(){

          var switchImg = $(".circ.active").attr("set-id");
          var setreqID = "#" + switchImg;
          var scrollToPos = $(setreqID).attr("step");
     	$('.owl-set-product').trigger('to.owl.carousel', scrollToPos);

}



// CART CHECK - Assess current cart


function check_cart(){
        //alert("checking for test");
        //var countsubsnew = countsubs;
       // alert(countsubsnew );
            var countsubs = 0;
        	var counttabs = 0;
       	 	var countbrush = 0;
        
            $.ajax({ 
                url: '/cart.js', 
                dataType: 'json', 
                async: false, 
                success: function(cart) {
                                // now have access to Shopify cart object
                                //alert('There are now ' + cart.item_count + ' items in the cart.');
                                //console.log(cart.items);
                                for (property in cart.items) {
                                  console.log(property + ":" + cart.items[property].product_id );
                                  var current_id = cart.items[property].product_id;
                                  var current_qty = cart.items[property].quantity;
                                  
                                  
                                  if(current_id == 4997152833672){
                                    countsubs++;
                                  }
                                  
                                  switch(current_id) {
                                    case 4997152833672:
                                      // tabs bimonthly
                                      counttabs = counttabs + current_qty;
                                      break;
                                    case 4996858642568:
                                      // tabs annual
                                      counttabs = counttabs + current_qty;
                                      break;
                                    case 4997166366856:
                                      // brush bimonthly
                                      countbrush = countbrush + current_qty;
                                      break;
                                    case 4506762576008:
                                      // brush annual
                                      countbrush = countbrush + current_qty;
                                      break;
                                    default:
                                      // code block
                                  } 
                                  
                                  
                                  
                                  
                                }
                  //console.log("Counted tabs " + counttabs);
                  //console.log("Counted brush" + countbrush);
                  
                  choosePopup(counttabs, countbrush); 
                  				
                                //console.log("Counted " + countsubs);
                                //console.log(countsubs);
                                return countsubs;
                                //console.log(cart.items[0].variant_id);
                        }
            });
        
        	console.log("testing end alt " + countsubs);
        	//console.log("return ");
          	//alert(countsubs);
          	//console.log("shhhh " + countsubsnew);
        
        //return count2;
        return countsubs;
      
      }
      
// Add to cart script ( original)

function addItemToCart (variant_id, quantity, shipping_interval_frequency, shipping_interval_unit_type, subscription_id) {
  //alert(variant_id + " " + quantity + " " +  shipping_interval_frequency + " " +  shipping_interval_unit_type + " " +  subscription_id);
  
  data = {
      "quantity": quantity,
      "id": variant_id,
      "properties[shipping_interval_frequency]": shipping_interval_frequency, 
	"properties[shipping_interval_unit_type]": shipping_interval_unit_type,            
	"properties[subscription_id]": subscription_id
    }
  jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function() { 
          //window.location.href = '/cart'; 
      }
  });
  //window.location = '/checkout';

}



window.addEventListener('load', function () {
  //resetBrushbox();  
})


function closeCart(){
	jQuery('#get-started').removeClass('js-drawer-open js-drawer-open-right');
    jQuery('#CartDrawer').removeClass('js-drawer-open');
   jQuery('html').removeClass('js-drawer-open js-drawer-open-right');
}

// On page load

jQuery(document).ready(function($) {
  
//resetBrushbox();
  
  
  
  
  
$('.drawer--right').on('classChanged', function(){ 

alert("yes");
});  
  
  
  
 
   jQuery('body').on('click','.but-go-back', function(evt, cart) {
   	closeCart();
  });
    
  
  
 
   jQuery('body').on('click','.but-another', function(evt, cart) {
  //timber.RightDrawer.close();
  });
  
  
  
//Get started - Moving elements for mobile version   
  
  
  if ($(window).width() < 768) {
   $(".brushbox-image-sect").appendTo(".place-image");  
   $(".but-add-contain").appendTo(".place-but");
}

  
  
  
  
  
  
  
  
  
   // Get height of all inner divs  
  

var maxHeight = 0;

$(".custom-featured .meta-contain").each(function(){
   if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
});

$(".custom-featured .meta-contain").height(maxHeight);


  
  
  

  
  
$( ".toggle-alt .circ" ).each(function() {

            
            
    // var pullid = $(this).attr('set-id')   
    // var setrequestid = "#" + pullid;
    //console.log(setrequestid);
    // var scrollpos = $(setrequestid).attr("step");
    // $('.owl-set-product').trigger('to.owl.carousel', scrollpos) ;
            
            
            
            
        });
  
  
  
  //Get started testing
  
  
  
  $('.single-option-radio input[name="option1"]').change(function(){
    if($(this).val() == 'Adult'){
       //alert("test");
      $('.opt-colour label[size="Child"]').addClass("hide-opt");
    }
});
  

  
  
  // Toggle options for brushbox get started
  $( ".option-size, .option-style, .option-tabs, .option-billing" ).click(function(evt) {
    var selecttog = $(".toggle", this);
    var theoption = $(this);
    //alert( "Handler for .click() called." );
    var clickedOn = $(evt.target);
    var chooseTab = "";
    var tabopt = $('.option-tabs').attr("value");
    
    if(tabopt == "yes"){
      chooseTab = "tabs";      
    }else{
    	chooseTab = "notabs";
    }
    //Set attribute
    var chooseval = clickedOn.attr("value");
    theoption.attr("value",chooseval);
    
    
    //alert(chooseval);
    
    
    switch(chooseval) {
        
      case 'no':
        
        $('.img-tabs').removeClass('tabs-show');
        var setbill = $(".option-billing").attr('value');
        
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          var sizeval = $(".option-size").attr('value');
          var getNewId = options[setbill].notabs[sizeval][thevar];
          $( this ).attr('set-id',getNewId);
          
        });
                //Change image ids to suit bimonthlyid
        var setbill = $(".option-billing").attr('value');
        $( ".owl-item .item" ).each(function() {
         var setSizeOpt = $(this).attr("size");
          var setcolOpt = $(this).attr("col");
         var lowersize = ""; 
          if(setSizeOpt == "Adult"){
           lowersize = "adult";
          }else{
            lowersize = "kid";
          }
          
          var setNewId = options[setbill].notabs[lowersize][setcolOpt];
          $(this).attr("id",setNewId);
        });
         
                // Revert to variant that matches the selection
        var chosenId;
        chosenId = $('.circ.active').attr('set-id');
    	$('.option-colour').attr('value', chosenId);
         
        
        break;
       case 'yes':
        
        var setbill = $(".option-billing").attr('value');
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          var sizeval = $(".option-size").attr('value');
          var getNewId = options[setbill].tabs[sizeval][thevar];
          $( this ).attr('set-id',getNewId);
          
        });
                 //Change image ids to suit bimonthlyid
        var setbill = $(".option-billing").attr('value');
        $( ".owl-item .item" ).each(function() {
         var setSizeOpt = $(this).attr("size");
          var setcolOpt = $(this).attr("col");
         var lowersize = ""; 
          if(setSizeOpt == "Adult"){
           lowersize = "adult";
          }else{
            lowersize = "kid";
          }
          
          var setNewId = options[setbill].tabs[lowersize][setcolOpt];
          $(this).attr("id",setNewId);
        });
        
        // Revert to variant that matches the selection
        var chosenId;
        chosenId = $('.circ.active').attr('set-id');
    	$('.option-colour').attr('value', chosenId);
        
        

        
        $('.img-tabs').addClass('tabs-show');  
        
        
        break;
      case 'curvy':
        
        // Choose between kid or adult curvy
        var optchosensize  = $(".option-size").attr("value");
        curvychoose(optchosensize);

        
        
        // Chosen option - default select
        $('.col-smooth').fadeOut( "slow");
        $('.col-smooth .circ, .col-curvy .circ').removeClass("active");
        $('.col-curvy').delay(800).fadeIn( "slow");
        
        
        
          if(optchosensize == "kid"){
            
            $('.col-curvy .opt-white-black').addClass("active");
            $('.owl-set-product').trigger('to.owl.carousel', '23');
            
          }else{
            $('.col-curvy .circ:nth-child(1)').addClass("active");
             $('.owl-set-product').trigger('to.owl.carousel', '8');
          }
                
        
        var curveval = $(".col-curvy .circ.active").attr("set-id");
    	$('.option-colour').attr("value",curveval);
        
        //goToCarousel();
        
        break;
      case 'smooth':
        
        
        $('.col-curvy').fadeOut( "slow");
        $('.col-smooth').delay(800).fadeIn( "slow");
        $('.col-smooth .circ:nth-child(1)').addClass("active");
        
        
        
        
        var optchosensize  = $(".option-size").attr("value");
         if(optchosensize == "kid"){
            
            $('.owl-set-product').trigger('to.owl.carousel', '15');
            
          }else{
            $('.owl-set-product').trigger('to.owl.carousel', '0');
          }
        
        
        var newSelected = $(".toggle-alt .col-smooth .circ:first-child.active").attr('set-id');
          $(".option-colour").attr('value', newSelected );
        
        //goToCarousel();
        
        break;
        
      case 'kid':
        
        
        // Choose between kid or adult curvy
        curvychoose("kid");

        
        //alert('yes');
        //$('.col-curvy').fadeOut( "slow");
        //$('.col-smooth').delay(800).fadeIn( "slow");
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          var billval = $(".option-billing").attr('value');
          //console.log($( this ).attr('set-id'));
          var getNewId = options[billval][chooseTab].kid[thevar];
          
          //console.log("new id: " +  getNewId);
          $( this ).attr('set-id',getNewId);
          
          var chosestyleopt = $('.option-style').attr("value");
          if(chosestyleopt == "curvy"){
            $(".col-curvy .circ").removeClass('active');
            $(".col-curvy .opt-red-white").addClass('active');
          }
          
          goToCarousel();
          
        });
        var newSelected = $(".toggle-alt .circ.active").attr('set-id');
          $(".option-colour").attr('value', newSelected );
        break;  
       case 'adult':
        
        
                
        // Choose between kid or adult curvy
        curvychoose("adult");
        
        //$('.col-curvy').fadeOut( "slow");
        //$('.col-smooth').delay(800).fadeIn( "slow");
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          var billval = $(".option-billing").attr('value');
          //console.log($( this ).attr('set-id'));
          var getNewId = options[billval][chooseTab].adult[thevar];
          //console.log("new id: " +  getNewId);
          $( this ).attr('set-id',getNewId);
          var chosestyleopt = $('.option-style').attr("value");
          if(chosestyleopt == "curvy"){
            $(".col-curvy .circ").removeClass('active');
            $(".col-curvy .circ:first-child").addClass('active');
          }
          
          goToCarousel();
        });
        var newSelected = $(".toggle-alt .circ.active").attr('set-id');
        $(".option-colour").attr('value', newSelected );
        
        
        break;
        
      
      	case 'bimonthly':
        
        
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
         // console.log($( this ).attr('set-id'));
          var sizeval = $(".option-size").attr('value');
          var getNewId = options.bimonthly[chooseTab][sizeval][thevar];
          //console.log("new id: " +  getNewId);
          $( this ).attr('set-id',getNewId);
          
          
          var chooseval
           var setrequestid = "#" + chooseval;
     		var scrollpos = $(setrequestid).attr("step");
     		$('.owl-set-product').trigger('to.owl.carousel', scrollpos);
          
          
        });
        
        //Change image ids to suit bimonthlyid
        $( ".owl-item .item" ).each(function() {
         var setSizeOpt = $(this).attr("size");
          var setcolOpt = $(this).attr("col");
         var lowersize = ""; 
          if(setSizeOpt == "Adult"){
           lowersize = "adult";
          }else{
            lowersize = "kid";
          }
          
          var setNewId = options.bimonthly[chooseTab][lowersize][setcolOpt];
          $(this).attr("id",setNewId);
        });
        
        var curveval = $(".circ.active").attr("set-id");
    	$('.option-colour').attr("value",curveval);
        
        break; 
        case 'annual':
        

        
        $( ".toggle-alt .circ" ).each(function() {
          var thevar = $( this ).attr('id');
          //console.log($( this ).attr('set-id'));
          var sizeval = $(".option-size").attr('value');
          var getNewId = options.annual[chooseTab][sizeval][thevar];
          //console.log("new id: " +  getNewId);
          $( this ).attr('set-id',getNewId);
        });
        
        //Change image ids to suit annual id
        $( ".owl-item .item" ).each(function() {
         var setSizeOpt = $(this).attr("size");
          var setcolOpt = $(this).attr("col");
         var lowersize = ""; 
          if(setSizeOpt == "Adult"){
           lowersize = "adult";
          }else{
            lowersize = "kid";
          }
          
          var setNewId = options.annual[chooseTab][lowersize][setcolOpt];
          $(this).attr("id",setNewId);
        });
        
         var curveval = $(".circ.active").attr("set-id");
    	$('.option-colour').attr("value",curveval);
        
        break; 
      default:
        // code block
    } 
    
    
    
    
    
    if (clickedOn.is('.tog-opt1')){

      if($(selecttog).hasClass("active-tog")){ 
        $(selecttog).removeClass("active-tog");
      }
      
    }
    if (clickedOn.is('.tog-opt2')){
      if($(selecttog).hasClass("active-tog")){
       
      }else{
         $(selecttog).addClass("active-tog");
      }
      
    }
    

  });
  
  
  
  
  // Choosing colour option
  $( ".option-colour").click(function(evt) {
    
    


    
        var selecttog = $(".toggle-alt", this);
    var theoption = $(this);
    var clickedOn = $(evt.target);
    
    
        //Set attribute
    var chooseval = clickedOn.attr("set-id");
    theoption.attr("value",chooseval);
    if(clickedOn.hasClass('circ')){
      $('.option-colour .circ').removeClass('active');
      clickedOn.addClass('active');
    }
    
  //Go to slide
    
        
     var setrequestid = "#" + chooseval;
    //console.log(setrequestid);
     var scrollpos = $(setrequestid).attr("step");
    //alert(scrollpos);
     $('.owl-set-product').trigger('to.owl.carousel', scrollpos);
    
    
    
  });
  
  
  
  // Ceckbox selection
  
  $(".option-brush input[type=checkbox]").change(function(){
    if ( this.checked ){
      $('.option-size, .option-style,.option-colour').addClass("disable-sect");
      $('.owl-set-product').addClass("hide-brush");
    }else{
      $('.option-size, .option-style,.option-colour').removeClass("disable-sect");
      $('.owl-set-product').removeClass("hide-brush");
    }
});
  
  
  // Listen for value attribute change
  
  $(".option-size[value]").change(function(){
      //alert( $(this).attr("value") );
   });
  

  
  
  // Get started end
  
  
  
  
  
  
  
  
  
  
  
  
  $(".drawer--left #Label-1, .drawer--left #Label-2").removeAttr("href");
  
  // Brushbox- defualt chsoen options
  
  $('.toggle-opt-size input[opt="opt-inp-0"], .toggle-opt-style input[opt="opt-inp-0"], .toggle-opt-tabs input[opt="opt-inp-0"]').prop("checked", true);
  $('.toggle-opt-size input[opt="opt-inp-1"], .toggle-opt-style input[opt="opt-inp-1"], .toggle-opt-tabs input[opt="opt-inp-1"]').prop("checked", false);
  
    // Toggle options for brushbox
  $( ".custom-featured .grid-product__wrapper" ).click(function(evt) {
    var clickedOn = $(evt.target);
    var relatedBox = $(".popup-related", this);
    var relatedimg = $(".related-select .icon-gen", this);
    if (clickedOn.is('.related-select .icon-gen')){
      if(relatedBox.hasClass("show-popup")){
      relatedBox.removeClass("show-popup");
      relatedimg.attr('src','https://cdn.shopify.com/s/files/1/2172/8211/files/magnify-glass.svg?v=1600853822');
      }else{
      relatedBox.addClass("show-popup");
        
        relatedimg.attr('src','https://cdn.shopify.com/s/files/1/2172/8211/files/close-grey.svg?v=1600853822');
      }
      
    }

  });
  
  
  
  
  
  
  
  
  // Toggle options for brushbox
  $( ".toggle-opt-size, .toggle-opt-style, .toggle-opt-tabs" ).click(function(evt) {
    var selecttog = $(".toggle", this);
    //alert( "Handler for .click() called." );
    var clickedOn = $(evt.target);
    
    if (clickedOn.is('.tog-opt-1')){
      if($(selecttog).hasClass("active-tog")){
      }else{
        $(selecttog).addClass("active-tog");
      }
      
    }
    
    if (clickedOn.is('.tog-opt-0')){
      if($(selecttog).hasClass("active-tog")){
        $(selecttog).removeClass("active-tog");
      }else{
      }
      
    }
    
    if (clickedOn.is(selecttog)){
      if(selecttog.hasClass("active-tog")){
        selecttog.removeClass("active-tog");
        $('input[opt="opt-inp-0"]',this).prop("checked", true);
        $('input[opt="opt-inp-1"]',this).prop("checked", false);
      }else{
        selecttog.addClass("active-tog");
        $('input[opt="opt-inp-1"]',this).prop("checked", true);
        $('input[opt="opt-inp-0"]',this).prop("checked", false);
      }
    }
  });
  
  
  
  
  
  
  
  
  
  
  
  //jQuery(".revealOnScroll").removeClass('animated fadeInUp fadeIn lightSpeedIn');
  
  
  var heightfirst = jQuery('#adults #opt-1').outerHeight();
  var heightsec = jQuery('#adults #opt-2').outerHeight();
  var result = Math.max(heightfirst,heightsec)
  //jQuery('#adults #opt-1').css('min-height', result);
  //jQuery('#adults #opt-2').css('min-height', result);

  myFunction();
  
  
  
   $(document).ready(function(){
  $('.owl-set-highlight').owlCarousel({
    loop:true,
        animateOut: 'fadeOutDown',
    animateIn: 'fadeInUp',
    margin:10,
    nav:true,
    dots: false,
    items:1,
        autoplay:true,
    autoplayTimeout:5000,
    autoplayHoverPause:true
})
  
  
  
  $('.owl-set-product').owlCarousel({
        animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    margin:10,
    nav:false,
    loop:false,
    dots: false,
    items:1,
    autoplay:false,
    mouseDrag:false,
})  
  
  
  
  
}); 
  
 
// announcement
  jQuery( ".close-announce" ).on( "click", function() {
    jQuery( ".announcement-bar" ).css( "height", jQuery( ".announcement-bar" ).height());
  jQuery( ".announcement-bar" ).slideUp(300);
});
  
  // Show additional brusbox pop up
  jQuery( ".brushbox-custom-template .product-single__add-to-cart" ).on( "click", function() {
    //alert("check but");
    window.setTimeout(function (){
      $('.popup-cover').addClass("show-popup-cover");
    
    }, 1500);
    window.setTimeout(function (){
      $('.popup-main').addClass("show-popup-main"); 
    
    }, 2000);
    
});
  
  // Close main pop up box 
  jQuery( ".popup-main .icon, .popup-main .close-popup" ).on( "click", function() {

    $('.popup-main').removeClass("show-popup-main");
    $('.popup-cover').removeClass("show-popup-cover");
    resetBrushbox();
    
    if($('.popup-main .icon-x').hasClass('next-tab')){
       timber.RightDrawer.close();
    	secondPopup();
       $('.popup-main .icon-x').removeClass('next-tab'); 
    };

    
    
});  
  
  
  
  
 
jQuery("#myInput").on( "input",function() {
  var x = jQuery("#myInput").val();
 // alert(x);
  jQuery('[data-option-name="name"] input').val(x);
});
 
});




// Accordion

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}





// POPUP - Chosen pop up

function choosePopup(opt1, opt2){
  var setImg, setTitle, setText, setBut, setBill;
  var numtabs = opt1;
  var numbrushes = opt2;
  //alert(numtabs + "&" + numbrushes);
  timber.RightDrawer.open();
  ajaxCart.load();
  
  // For single brush in basket
     setImg = "https://cdn.shopify.com/s/files/1/2172/8211/files/pop-more.jpg?v=1600853639";
    setTitle = "The more the merrier!";
    setText = '<p>Treat the whole family, gift to a friend or get the office involved!</p>';
    setBut = '<span type="button" onclick="timber.RightDrawer.close();resetBrushbox();" class="btn btn-fill btn-org margin-b-xs but-another">Add another person</span><span onclick="timber.RightDrawer.close();secondPopup();" class="btn btn-outline btn-org">Go to checkout</span></div>';
    

  
  $('.popup-main .pop-img').css("background-image", "url(" + setImg + ")"); 
  $('.popup-main .pop-title').html(setTitle); 
  $('.popup-main .pop-cont').html(setText); 
  $('.popup-main .pop-but').html(setBut); 
  
      $('.popup-main').addClass("show-popup-main");
    $('.popup-cover').addClass("show-popup-cover");
}





// POPUP - Chosen pop up

function tabsPopup(){
  var setImg, setTitle, setText, setBut, setBill;
  timber.RightDrawer.open();
  ajaxCart.load();
  
        
  $('.popup-main').addClass("show-popup-main");
  
  
  
  
    setImg = "https://cdn.shopify.com/s/files/1/2172/8211/files/tabs_glass_jar_square-02.jpg?v=1600853554";
    setTitle = "Keep a tab on things";
    setText = '<p>Your tabs need to stay looking good and fresh in our air-tight jars!</p><div class="h4 font-gen">£10.00</div>';
    setBut = '<span type="button" onclick="AddToBagGrid(32851675414603);ajaxCart.load();resetBrushbox();" class="btn btn-outline btn-org  but-4506762576008">Add to order</span><div onclick="resetBrushbox()" class="h4 margin-t-xs font-gen col-d-gry close-popup"><u>No thanks</u></div>';
  
  
  $('.popup-main .pop-img').css("background-image", "url(" + setImg + ")"); 
  $('.popup-main .pop-title').html(setTitle); 
  $('.popup-main .pop-cont').html(setText); 
  $('.popup-main .pop-but').html(setBut); 
  
      $('.popup-main').addClass("show-popup-main");
    $('.popup-cover').addClass("show-popup-cover");
}







//Tabs


function openCity(evt, cityName) {
  
  var i, tabcontent, tablinks, imglinks, parID, curSEL;
  
  var curSEL = evt.target;
  	parID = $(evt.target).closest('.sect-tabs').attr('id');
  	//alert("#" + parID);

  
  tabcontent = document.getElementById(parID).getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    
  }
  tablinks = document.getElementById(parID).getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  imglinks = document.getElementById(parID).getElementsByClassName("imglinks");
  for (i = 0; i < imglinks.length; i++) {
    imglinks[i].className = imglinks[i].className.replace(" active", "");
  }
  
  
  var imgId = 'img-' + cityName;
  if (imgId != null) {
  	//document.getElementById(imgId).className += ' active';
    $("#"+ parID + " #"+ imgId).addClass("active");
  }
  
  //document.getElementById(cityName).style.display = "block";
  $("#"+ parID + " #"+ cityName).css("display", "block");
  evt.currentTarget.className += " active";
}









function tabChoose(evt, cityName) {
  
    var curSEL = evt.target;
  	parID = $(evt.target).closest('.sect-tabs').attr('id');
  
  
  
  
  var i, tabcontent, tablinks;
  tabcontent = document.getElementById(parID).getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    
  }
  tablinks = document.getElementById(parID).getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
 
  }
  
  
  imglinks = document.getElementById(parID).getElementsByClassName("imglinks");
  for (i = 0; i < imglinks.length; i++) {
    imglinks[i].className = imglinks[i].className.replace(" active", "");
  }
  
  
  var imgId = 'img-' + cityName;
  if (imgId != null) {
  	document.getElementById(imgId).className += ' active';
  }  
  
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";

}


function tabChooseOri(evt, cityName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
 
  }
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += " active";

}

$(function() {

  var $window           = $(window),
      win_height_padded = $window.height(),
      isTouch           = Modernizr.touch;
  
  //alert($window.height() * 1.1);

  if (isTouch) { $('.revealOnScroll').addClass('animated'); }

  $window.on('scroll', revealOnScroll);

  function revealOnScroll() {
    var scrolled = $window.scrollTop(),
        win_height_padded = $window.height();

    // Showed...
    $(".revealOnScroll:not(.animated)").each(function () {
      var $this     = $(this),
          offsetTop = $this.offset().top;

      if (scrolled + win_height_padded > offsetTop) {
        if ($this.data('timeout')) {
          window.setTimeout(function(){
            $this.addClass('animated ' + $this.data('animation'));
          }, parseInt($this.data('timeout'),10));
        } else {
          $this.addClass('animated ' + $this.data('animation'));
        }
      }
    });
    // Hidden...
   /*$(".revealOnScroll.animated").each(function (index) {
      var $this     = $(this),
          offsetTop = $this.offset().top;
      if (scrolled + win_height_padded < offsetTop) {
        $(this).removeClass('animated fadeInUp fadeIn lightSpeedIn')
      }
    });*/
  }

  revealOnScroll();
  
  // Hide blocks that follow scroll position on page as you scroll down page.
  function hideblocks(){
  var scrolled = $window.scrollTop();
   	   $(".revealOnScroll.animated").each(function (index) {
         
       var $this = $(this),
       offsetTop = $this.offset().top;
        if (scrolled + win_height_padded < offsetTop) {
          $(this).removeClass('animated fadeInUp fadeIn lightSpeedIn');
        }
      });
  }
  hideblocks();

});




